import { CSSProperties, useRef } from 'react';

import { renderComponent } from 'utils';
import { Ripple } from '..';

import styles from './Button.module.scss';

export type ButtonProps = {
  type?: 'primary' | 'secondary' | 'disabled' | 'danger' | 'safe';
  icon?: React.ElementType;
  align?: 'left' | 'right';
  onClick?: () => void;
  style?: { root?: CSSProperties; text?: CSSProperties };
};

const Button: React.FC<ButtonProps> = props => {
  const { type = 'primary', icon, align = 'left', onClick } = props;
  const ref = useRef<HTMLDivElement>(null);
  const classes = [styles.button, styles[type]];

  if (icon) {
    classes.push(styles.icon, styles[align]);
  }

  const onKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && ref.current) {
      ref.current.click();
    }
  };

  return (
    <div
      ref={ref}
      className={classes.join(' ')}
      onClick={onClick}
      tabIndex={type !== 'disabled' ? 0 : -1}
      onKeyDown={onKeyDown}
      style={props.style?.root}
    >
      <div tabIndex={-1}>
        {icon && <div className={styles.icon}>{renderComponent(icon)}</div>}

        <div className={styles.text} style={props.style?.text}>
          {props.children}
        </div>

        {type !== 'disabled' && (
          <Ripple parentRef={ref} folowCursor={true} size="2w"></Ripple>
        )}
      </div>
    </div>
  );
};

export default Button;
